module.exports = __webpack_public_path__ + "media/flags/sj-600ff9eb.svg";